import { Card, Select, Row, Col, Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { exportToExcel } from "./exportToExcel";

const { Option } = Select;

export default function ReportFilters({ filters, setFilters, data, filteredData }) {
  const proyectos = data?.table
    ? [...new Set(data.table.map((item) => item.proyecto))]
    : [];
  const resetFilters = () => {
    setFilters({
      proyecto: "",
      tipo: "",
      mes: "all",  
    });
  };
  const handleFilterChange = (key, value) => {
    setFilters({ ...filters, [key]: value });
  };
const handleExport = () => {
    exportToExcel(filteredData, "informe_seguimiento.xlsx");
  };
  return (
    <Card style={{padding: '10px',marginLeft: '10px', paddingBottom: '10px', borderRadius: '8px', paddingTop: '10px', marginBottom: '20px' }}>
      <Row gutter={[16, 16]}>
        <Col xs={24} md={8}>
          <Select
            placeholder="Seleccionar proyecto"
            value={filters.proyecto || undefined}
            onChange={(value) => handleFilterChange("proyecto", value)}
            style={{ width: "100%" }}
            allowClear
            showSearch
            optionFilterProp="children"
          >
            <Option value="all">Todos los proyectos</Option>
            {proyectos.map((proy) => (
              <Option key={proy} value={proy}>
                {proy}
              </Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} md={8}>
          <Select
            placeholder="Seleccionar tipo"
            value={filters.tipo || undefined}
            onChange={(value) => handleFilterChange("tipo", value)}
            style={{ width: "100%" }}
            allowClear
          >
            <Option value="todos">Todos</Option>
            <Option value="acompanamiento">Acompañamiento</Option>
            <Option value="capacitacion">Capacitación</Option>
          </Select>
        </Col>
        <Col xs={24} md={3}>
          <Button
            onClick={resetFilters}
            style={{
              width: "100%",
              borderRadius: 6,
            }}
          >
            Limpiar filtros
          </Button>
        </Col>
        <Col xs={24} md={5}>
         <Button
          type="primary"
          icon={<DownloadOutlined />}
          onClick={handleExport}
        >
          Exportar Excel
        </Button>
        </Col>
      </Row>
    </Card>
  );
}
